import { useContext } from 'react';
import { MyReactionsBatchContext, type MyReactionsBatchContextType } from '@/contexts/MyReactionsContext';

/** Access the batched my-reaction loader. Must be used within MyReactionsProvider. */
export function useMyReactionsBatch(): MyReactionsBatchContextType {
  const context = useContext(MyReactionsBatchContext);
  if (context === undefined) {
    throw new Error('useMyReactionsBatch must be used within a MyReactionsProvider');
  }
  return context;
}
